// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yM-z","inlineTitle":"zM-z","sponsoredAdsWrapper":"AM-z","marketplaceRecosWrapper":"BM-z"};